import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ComputedFrom } from '@certemy/common';
import {
  DEFAULT_LABEL_SETTINGS,
  GlobalOrganizationsLabel,
  OrganizationsLabelType,
} from 'features/global-organizations-setting-state/global-organizations-setting.constant';
import { ORGANIZATION_TYPE } from 'constants/constants';
import {
  DEFAULT_PROFILE_TYPE_ID_NAMES,
  PROFILE_TYPE_ID,
  PROFILE_TYPE_ID_ORGANIZATIONS_LABEL_MAPPER,
} from 'components/organization-users/users/users.constants';
import { IPermissions } from 'services/policy-permission/policy-permissions.service';
import {
  DEFAULT_PROFESSIONAL_CARD_PERMISSIONS,
  PROFESSIONAL_CARD_POLICIES_KEYS,
  ProfessionalCardService,
} from 'features/assignments/shared/prof-card/professional-card.service.module';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

interface ProfessionalCard {
  email: string;
  firstName: string;
  id: number;
  lastName: string;
  roleId: number;
  profileTypeId: PROFILE_TYPE_ID;
  organizationProfileId?: string;
  organizationCountryName?: string;
  organizationOfficeName?: string;
  organizationRegionName?: string;
  organizationRoleId?: number;
  organizationRoleName?: string;
}

@UntilDestroy()
@Component({
  selector: 'cm-professional-card',
  templateUrl: './professional-card.component.html',
  styleUrls: ['./professional-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfessionalCardComponent implements OnInit, OnDestroy {
  @Input() professional: ProfessionalCard;
  @Input() short: boolean = false;
  organizationLabels: GlobalOrganizationsLabel = DEFAULT_LABEL_SETTINGS;
  organizationTypeId: ORGANIZATION_TYPE;
  showMore = false;
  permissions: IPermissions<PROFESSIONAL_CARD_POLICIES_KEYS> = DEFAULT_PROFESSIONAL_CARD_PERMISSIONS;

  readonly OrganizationsLabelType = OrganizationsLabelType;

  constructor(private professionalCardService: ProfessionalCardService) {}

  ngOnInit() {
    this.professionalCardService.data$
      .pipe(untilDestroyed(this))
      .subscribe(({ permissions, labels, organizationTypeId }) => {
        this.permissions = permissions;
        this.organizationLabels = labels;
        this.organizationTypeId = organizationTypeId;
      });
  }

  ngOnDestroy() {}

  @ComputedFrom('professional', 'organizationLabels')
  get profileTypeLabel(): string {
    const { profileTypeId } = this.professional;
    const labelTypeId = PROFILE_TYPE_ID_ORGANIZATIONS_LABEL_MAPPER[profileTypeId];
    return labelTypeId ? this.organizationLabels[labelTypeId] : DEFAULT_PROFILE_TYPE_ID_NAMES[profileTypeId];
  }

  get showDetailsLabel(): string {
    return this.showMore ? 'Show less' : 'Show more';
  }

  toggleDetails(event) {
    event.stopPropagation();
    this.showMore = !this.showMore;
  }
}
